import React, { useState, useEffect } from 'react';
import AdminLayout from './AdminLayout';
import '../App.css';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalProfiles: 0,
    totalUsers: 0,
    totalAdmins: 0,
    recentProfiles: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setStats({
        totalProfiles: 45,
        totalUsers: 120,
        totalAdmins: 8,
        recentProfiles: 12
      });
      setLoading(false);
    } catch (error) {
      console.error('Error fetching stats:', error);
      setLoading(false);
    }
  };

  return (
    <AdminLayout pageTitle="Dashboard">
          {/* Stats Cards */}
          <div className="stats-grid">
            <div className="stat-card stat-orange">
              <div className="stat-icon">
                      <i className="fi fi-rr-chart-line-up"></i>
                    </div>
              <div className="stat-info">
                <div className="stat-label">Total Sales</div>
                <div className="stat-value">$1,345</div>
              </div>
            </div>

            <div className="stat-card stat-green">
              <div className="stat-icon">
                      <i className="fi fi-rr-users"></i>
                    </div>
              <div className="stat-info">
                <div className="stat-label">Total Users</div>
                <div className="stat-value">1,303</div>
              </div>
            </div>

            <div className="stat-card stat-blue">
              <div className="stat-icon">
                      <i className="fi fi-rr-user-check"></i>
                    </div>
              <div className="stat-info">
                <div className="stat-label">Active Users</div>
                <div className="stat-value">856</div>
              </div>
            </div>
          </div>

          {/* Charts Section */}
          <div className="charts-grid">
            <div className="chart-card">
              <div className="chart-header">
                  <div>
                  <h3>Sales Analytics</h3>
                  <p>Monthly performance metrics</p>
                  </div>
                <select className="chart-select">
                      <option>Last 30 Days</option>
                      <option>Last 7 Days</option>
                      <option>Last 90 Days</option>
                    </select>
                  </div>
              <div className="chart-body">
                    <svg width="100%" height="300" style={{ overflow: 'visible' }}>
                      {[0, 1, 2, 3, 4, 5].map((i) => (
                        <line
                          key={i}
                          x1="60"
                          y1={40 + i * 50}
                          x2="calc(100% - 40)"
                          y2={40 + i * 50}
                          stroke="#eef0f3"
                          strokeWidth="1"
                          strokeDasharray="2,2"
                        />
                      ))}
                      {['$50k', '$40k', '$30k', '$20k', '$10k', '$0'].map((label, i) => (
                        <text
                          key={i}
                          x="55"
                          y={40 + i * 50}
                          textAnchor="end"
                          fill="#6b7177"
                          fontSize="11"
                          fontWeight="500"
                          alignmentBaseline="middle"
                        >
                          {label}
                        </text>
                      ))}
                      <polyline
                        points="80,280 120,240 160,200 200,160 240,140 280,120 320,100 360,80 400,60 440,50"
                        fill="none"
                        stroke="#25b865"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <polyline
                        points="80,290 120,260 160,230 200,210 240,200 280,190 320,180 360,170 400,160 440,150"
                        fill="none"
                        stroke="#3e97ff"
                        strokeWidth="3"
                        strokeDasharray="6,4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'].map((label, i) => (
                        <text
                          key={i}
                          x={80 + i * 40}
                          y="290"
                          textAnchor="middle"
                          fill="#6b7177"
                          fontSize="11"
                          fontWeight="500"
                        >
                          {label}
                        </text>
                      ))}
                      <g transform="translate(60, 20)">
                        <circle cx="0" cy="0" r="5" fill="#25b865" />
                        <text x="12" y="4" fill="#252f4a" fontSize="12" fontWeight="500">Revenue</text>
                        <circle cx="100" cy="0" r="5" fill="#3e97ff" />
                        <text x="112" y="4" fill="#252f4a" fontSize="12" fontWeight="500">Sales</text>
                      </g>
                    </svg>
              </div>
            </div>

            <div className="chart-card">
              <div className="chart-header">
                  <div>
                  <h3>Performance</h3>
                  <p>Weekly statistics</p>
                </div>
              </div>
              <div className="chart-body">
                    <svg width="100%" height="280" style={{ overflow: 'visible' }}>
                      {[0, 1, 2, 3, 4].map((i) => (
                        <line
                          key={i}
                          x1="50"
                          y1={40 + i * 60}
                          x2="calc(100% - 30)"
                          y2={40 + i * 60}
                          stroke="#eef0f3"
                          strokeWidth="1"
                          strokeDasharray="2,2"
                        />
                      ))}
                      {['100', '80', '60', '40', '20'].map((label, i) => (
                        <text
                          key={i}
                          x="45"
                          y={40 + i * 60}
                          textAnchor="end"
                          fill="#6b7177"
                          fontSize="11"
                          fontWeight="500"
                          alignmentBaseline="middle"
                        >
                          {label}
                        </text>
                      ))}
                      {[
                        { value: 75, color: '#3e97ff', label: 'Mon' },
                        { value: 85, color: '#25b865', label: 'Tue' },
                        { value: 60, color: '#e49e3d', label: 'Wed' },
                        { value: 90, color: '#3e97ff', label: 'Thu' },
                        { value: 70, color: '#25b865', label: 'Fri' },
                        { value: 95, color: '#6f42c1', label: 'Sat' },
                        { value: 80, color: '#3e97ff', label: 'Sun' },
                      ].map((bar, i) => {
                        const barWidth = 35;
                        const barHeight = (bar.value / 100) * 240;
                        const x = 60 + i * 50;
                        const y = 280 - barHeight;
                        return (
                          <g key={i}>
                            <rect
                              x={x}
                              y={y}
                              width={barWidth}
                              height={barHeight}
                              fill={bar.color}
                              rx="4"
                              ry="4"
                            />
                            <text
                              x={x + barWidth / 2}
                              y="295"
                              textAnchor="middle"
                              fill="#6b7177"
                              fontSize="11"
                              fontWeight="500"
                            >
                              {bar.label}
                            </text>
                            <text
                              x={x + barWidth / 2}
                              y={y - 5}
                              textAnchor="middle"
                              fill="#252f4a"
                              fontSize="10"
                              fontWeight="600"
                            >
                              {bar.value}%
                            </text>
                          </g>
                        );
                      })}
                    </svg>
                  </div>
                </div>
              </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
